import {
  EditCard,
  EditCardProps,
} from "@greeter-venue/components/EditCard/EditCard";
import { classNames } from "@greeter/util";
import { formatMoney } from "@greeter/formatters";

import css from "./EditProductCard.module.scss";

export interface EditProductCardProps extends EditCardProps {
  imageUrl: string;
  price: number;
  discountPrice?: number;
}

export function EditProductCard({
  price,
  style,
  className,
  ...props
}: EditProductCardProps) {
  return (
    <EditCard
      {...props}
      {...classNames(className, css.EditProductCard)}
      ratio="4:3"
    >
      <div className={css.HorizontalLine} />
      <div className={css.Footer}>
        {props.discountPrice && (
          <div className={css.Price}>
            <s>{formatMoney(price)}</s> {formatMoney(props.discountPrice)} kr.
          </div>
        )}
        {!props.discountPrice && (
          <div className={css.Price}>{formatMoney(price)} kr.</div>
        )}
      </div>
    </EditCard>
  );
}
